import Vue from 'vue';
import Vuex from 'vuex';
import game from './modules/game';
import ui from './modules/ui';
import connection from './modules/connection';
import substitute from './modules/substitute';
import dmr from './modules/dmr';
import clock from './modules/clock';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        game,       // Meccs adatok (csapatok, események, gamedata)
        ui,         // App megjelenés (darkmode, sidebar, dialogok)
        connection,  // Socket státusz, sync
        substitute,
        dmr,
        clock
    }
});
